import { FormEvent, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/stores/authStore'

export function LoginPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, login, loading } = useAuthStore()
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)

  const redirectTo =
    (location.state as { from?: string } | null)?.from ?? '/dashboard'

  if (user) {
    return <Navigate to={redirectTo} replace />
  }

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)

    try {
      await login(password)
      navigate(redirectTo, { replace: true })
    } catch {
      setError('Invalid password')
    }
  }

  return (
    <div className="flex h-full items-center justify-center px-4 pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)]" data-testid="login-page">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-4 rounded-lg border border-border bg-card p-6 shadow-sm"
      >
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-primary">ModelScout</p>
          <h1 className="text-xl font-semibold">Sign in</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Enter the admin password to access the lab.
          </p>
        </div>

        <label className="block space-y-1">
          <span className="text-sm font-medium">Password</span>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
            autoComplete="current-password"
            data-testid="login-password"
          />
        </label>

        {error ? (
          <p className="text-sm text-destructive" data-testid="login-error">
            {error}
          </p>
        ) : null}

        <Button type="submit" className="w-full" disabled={loading || !password} data-testid="login-submit">
          {loading ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </div>
  )
}
